import type { StatusPreset } from './types'

/**
 * Document publication status is derived from `publishedAt` rather than a
 * stored enum, so consumers pass the timestamp (or null) instead of a key.
 */
export function docStatusPreset(
  publishedAt: Date | string | null,
): StatusPreset {
  return publishedAt
    ? { label: 'Published', tone: 'success' }
    : { label: 'Draft', tone: 'neutral' }
}
